import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { RequisitionsFormHttpClient } from './form.http-client';
import { RequisitionsFormActions } from './form.store';

@Injectable({ providedIn: 'root' })
export class RequisitionsFormEffects {
  public effects = createEffectFactory(RequisitionsFormActions, this.actions$);

  public fetch$ = this.effects(RequisitionsFormActions.fetch, () =>
    this.http.fetch().pipe(map(data => data.form)),
  );

  public update$ = this.effects(RequisitionsFormActions.update, ({ payload }) =>
    this.http.update({ form: payload }).pipe(map(data => data.form)),
  );

  public deleteField$ = this.effects(RequisitionsFormActions.deleteField, ({ payload }) =>
    this.http.delete(payload.field).pipe(
      map(data => data.form),
      map(form => RequisitionsFormActions.deleteFieldSuccess({ payload: form })),
      catchError(error => of(RequisitionsFormActions.deleteFieldFailed({ payload: { error } }))),
    ),
  );

  public deleteCustomField$ = this.effects(
    RequisitionsFormActions.deleteCustomField,
    ({ payload }) =>
      this.http.deleteCustomField(payload.id).pipe(
        map(data => data.form),
        map(form => RequisitionsFormActions.deleteCustomFieldSuccess({ payload: form })),
        catchError(error =>
          of(RequisitionsFormActions.deleteCustomFieldFailed({ payload: { error } })),
        ),
      ),
  );

  constructor(
    private actions$: Actions,
    private http: RequisitionsFormHttpClient,
  ) {}
}
